module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.inputLabel))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-center"
  }, [_vm._v("藥盒數量 (" + _vm._s(this.selectedDrug.pack_content) + " pc/盒)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.packCount),
      expression: "packCount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.packCount)
    },
    on: {
      "click": function($event) {
        _vm.showPackPad = true
      },
      "keydown": function($event) {
        _vm.showPackPad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.packCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPackPad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.defaultPackCount
    },
    on: {
      "saveNumber": _vm.savePackCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h6', {
    staticClass: "text-center"
  }, [_vm._v("散藥數量（pc）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pieceCount),
      expression: "pieceCount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.pieceCount)
    },
    on: {
      "click": function($event) {
        _vm.showPiecePad = true
      },
      "keydown": function($event) {
        _vm.showPiecePad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pieceCount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPiecePad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.defaultPieceCount
    },
    on: {
      "saveNumber": _vm.savePieceCount
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "total-amount--text"
  }, [_vm._v("總數量：" + _vm._s(_vm.storageAmount))])], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setNum
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18830784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/PackAndPieceSet.vue
// module id = 1402
// module chunks = 1